// vuex dependency
import * as types from '../mutation-types'
// prismic
import Prismic from 'prismic-javascript'

const state = {
	width: 0,
	height: 0,
	device: null,
	fetched: false,
	data: null,
	filtered: null,
	category: null,
	mask: null,
	touch: !!('ontouchstart' in window),
	color: '#000000'
}

// actions
const actions = {
	fetchData ({ commit }) {
		// temp
		Prismic.getApi('//haerepictures.prismic.io/api/v2')
			.then((api) => {
				return api.query(
					Prismic.Predicates.at('document.type', 'image'),
					{ fetchLinks: 'category.featured, category.name', pageSize: 100 }
					// { orderings: '[image.last_publication_date]' }
					// { pageSize: 1 }
				)
			})
			.then(
				(response) => {
					setTimeout(() => {
						commit(types.SET_IMAGES, response.results)
						commit(types.APP_FETCHED)
					}, 500)
				},
				(err) => {
					console.log(err)
				}
			)
	},
	filterImages ({ commit }, query) {
		commit(types.FILTER_IMAGES, query)
	},
	updateColor ({ commit }, color) {
		commit(types.UPDATE_COLOR, color)
	},
	updateMask ({ commit }, mask) {
		commit(types.UPDATE_MASK, mask)
	}
}

// mutations
const mutations = {
	[types.RESIZE] (state, payload) {
		state.width = payload.width
		state.height = payload.height
		state.device = payload.device
	},

	[types.APP_FETCHED] (state, payload) {
		state.fetched = true
	},

	[types.SET_IMAGES] (state, payload) {
		state.data = payload
	},

	[types.FILTER_IMAGES] (state, slug) {
		state.filtered = state.data.filter((i) => i.data.category.slug === slug)
		state.category = state.filtered[0].data.category.data.name
		state.mask = state.filtered[0].data.category.slug
	},

	[types.UPDATE_COLOR] (state, color) {
		state.color = color
	},

	[types.UPDATE_MASK] (state, mask) {
		state.mask = mask
	}
}

export default {
	state,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/app.js